import './App.css';
import "bootstrap/dist/css/bootstrap.css"
import AdminRouter from './Routers';
import "./Assets/css/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { NotificationProvider } from './Components/GlobalNotification';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_g0pts4aq5crm6eOO4UArhwOc00VgWF2pmg');

function App() {
  return (
    <NotificationProvider>
      <Elements stripe={stripePromise}>
        <AdminRouter />
      </Elements>
    </NotificationProvider>
  );
}

export default App;
